import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function loyaltyStartProTrial() {
  pushClevertapEvent('Loyalty Pro Trial Subscription Start');
}

export function loyaltyStartBasic() {
  pushClevertapEvent('Loyalty Basic Subscription Start');
}

export function loyaltyStartProUpgrade() {
  pushClevertapEvent('Loyalty Upgrade Pro Start');
}

export function loyaltyStart() {
  pushClevertapEvent('Loyalty Start');
}

export function loyaltyVideoStart() {
  pushClevertapEvent('Loyalty Video');
}

export function createProgramStart() {
  pushClevertapEvent('Loyalty Create Program Start');
}

export function createProgramType(programTypeInfo) {
  pushClevertapEvent(
    'Loyalty Create Program Type',
    loyaltyProgramTypeClevertapInfo(programTypeInfo)
  );
}

export function createProgramReward(rewardInfo) {
  pushClevertapEvent(
    'Loyalty Create Reward',
    loyaltyRewardClevertapInfo(rewardInfo)
  );
}

export function createConfiguration(data) {
  pushClevertapEvent('Loyalty Create Configuration', {
    'Send validation code': data.sentValidationCode,
  });
  pushClevertapEvent('Loyalty Create Save');
}

export function createLoyaltySuccess(programInfo) {
  pushClevertapEvent(
    'Loyalty Create Confirm Program Success',
    loyaltyProgramInfoToClevertapInfo(programInfo)
  );
}

export function createLoyaltyFail(displayErrorMessage, error) {
  pushClevertapEvent('Loyalty Create Confirm Program Failed', {
    'Error Message Display': displayErrorMessage,
    'Error Message Detail': error.message,
  });
}

function loyaltyProgramTypeClevertapInfo(data) {
  let programType;
  let transactionValue = 0;
  let transactionPointAmount = 0;
  const newMemberPointAmount = data.newMemberPoint;
  let itemPayload;

  if (data.earningRuleType === 'SPENDING') {
    programType = 'Gain Point from total Rp spent';
    transactionValue = data.spendingAmount;
    transactionPointAmount = data.pointFromSpendingAmount;
  } else if (data.earningRuleType === 'ITEM') {
    if (
      data.itemRules[0].type === 'ITEM' ||
      data.itemRules[0].type === 'ITEM_VARIANT'
    ) {
      programType = 'Gain Point from buying an item';
      transactionPointAmount = data.pointFromBuyingItem;
      itemPayload = data.itemRules.reduce((itemPayload, item, index) => {
        itemPayload[`Item Name ${index + 1} Value`] = item.item_name;
        itemPayload[`Item Variant ${index + 1} Value`] =
          item.item_variant_names;
        return itemPayload;
      }, {});
    } else {
      programType = 'Gain Point from buying any items from a category';
      transactionPointAmount = data.pointFromBuyingItem;
      itemPayload = data.itemRules.reduce((itemPayload, item, index) => {
        itemPayload[`Item Category ${index + 1} Value`] = item.category_name;
        return itemPayload;
      }, {});
    }
  }

  return {
    'Program Type': programType,
    'Transaction Value': transactionValue,
    'Transaction Point Amount': transactionPointAmount,
    'New Member Point Amount': newMemberPointAmount,
    ...itemPayload,
  };
}

function loyaltyRewardClevertapInfo(data) {
  let itemPayload;
  const rewardPayload = data.rewards.reduce((rewardPayload, reward, index) => {
    if (reward.discountType === 'AMOUNT') {
      rewardPayload[`Reward Type ${index + 1}`] = 'Rp discount on total sale';
      rewardPayload[`Discount Rp ${index + 1} Value`] = `Rp ${reward.discount}`;
    } else if (reward.discountType === 'PERCENTAGE') {
      if (reward.rewardType === 'TOTAL_SALES') {
        rewardPayload[`Reward Type ${index + 1}`] = '% discount on total sale';
      } else if (
        reward.rewardType === 'ITEM' &&
        (reward.rewardItems[0].type === 'ITEM' ||
          reward.rewardItems[0].type === 'ITEM_VARIANT')
      ) {
        rewardPayload[`Reward Type ${index + 1}`] =
          '% discount on specific item';
        itemPayload = reward.rewardItems.reduce((itemPayload, item, index) => {
          itemPayload[`Reward Item ${index + 1}`] = item.item_name;
          itemPayload[`Reward Item Variants ${index + 1}`] =
            item.item_variant_names;
          return itemPayload;
        }, {});
      } else if (
        reward.rewardType === 'ITEM' &&
        reward.rewardItems[0].type === 'CATEGORY'
      ) {
        rewardPayload[`Reward Type ${index + 1}`] =
          '% discount on any items from a category';
        itemPayload = reward.rewardItems.reduce((itemPayload, item, index) => {
          itemPayload[`Reward Item Category ${index + 1}`] = item.category_name;
          return itemPayload;
        }, {});
      }
      rewardPayload[`Discount % ${index + 1} Value`] = `${reward.discount} %`;
    }
    rewardPayload[`Redeem Point ${index + 1}`] = reward.point;
    rewardPayload[`Maximum Discount ${index + 1} Value`] =
      reward.maximumDiscount;
    rewardPayload[`Minimum Purchase ${index + 1} Value`] =
      reward.minimumPurchase;
    return rewardPayload;
  }, {});

  return {
    ...rewardPayload,
    ...itemPayload,
  };
}

function loyaltyProgramInfoToClevertapInfo(data) {
  let programType;
  let transactionValue = 0;
  const transactionPointAmount = data.earning_rules[0].point;
  const newMemberPointAmount = data.new_member_point;
  let itemProgramPayload;
  let itemRewardPayload;
  let itemCategoryRewardPayload;

  if (data.earning_rules[0].type === 'SPENDING') {
    programType = 'Gain Point from total Rp spent';
    transactionValue = data.earning_rules[0].amount;
  } else if (data.earning_rules[0].type === 'ITEM') {
    if (
      data.item_rules[0].type === 'ITEM' ||
      data.item_rules[0].type === 'ITEM_VARIANT'
    ) {
      programType = 'Gain Point from buying an item';
      itemProgramPayload = data.item_rules.reduce(
        (itemPayload, item, index) => {
          itemPayload[`Item Name ${index + 1} Value`] = item.item_name;
          itemPayload[`Item Variant ${index + 1} Value`] =
            item.item_variant_names;
          return itemPayload;
        },
        {}
      );
    } else {
      programType = 'Gain Point from buying any items from a category';
      itemProgramPayload = data.item_rules.reduce(
        (itemPayload, item, index) => {
          itemPayload[`Item Category ${index + 1} Value`] = item.category_name;
          return itemPayload;
        },
        {}
      );
    }
  }

  const rewardPayload = data.rewards.reduce((rewardPayload, reward, index) => {
    if (reward.discount_type === 'AMOUNT') {
      rewardPayload[`Reward Type ${index + 1}`] = 'Rp discount on total sale';
      rewardPayload[`Discount Rp ${index + 1} Value`] = `Rp ${reward.discount}`;
      rewardPayload[
        `Minimum Purchase ${index + 1} Value`
      ] = `Rp ${reward.min_purchase_amount}`;
    } else if (reward.discount_type === 'PERCENTAGE') {
      if (reward.reward_type === 'TOTAL_SALES') {
        rewardPayload[`Reward Type ${index + 1}`] = '% discount on total sale';
        rewardPayload[
          `Maximum Discount ${index + 1} Value`
        ] = `Rp ${reward.max_discount_amount}`;
      } else if (
        reward.reward_type === 'ITEM' &&
        (reward.reward_items[0].type === 'ITEM' ||
          reward.reward_items[0].type === 'ITEM_VARIANT')
      ) {
        rewardPayload[`Reward Type ${index + 1}`] =
          '% discount on specific item';
        itemRewardPayload = reward.reward_items.reduce(
          (itemPayload, item, index) => {
            itemPayload[`Reward Item ${index + 1}`] = item.item_name;
            itemPayload[`Reward Item Variants ${index + 1}`] =
              item.item_variant_names;
            return itemPayload;
          },
          {}
        );
      } else if (
        reward.reward_type === 'ITEM' &&
        reward.reward_items[0].type === 'CATEGORY'
      ) {
        rewardPayload[`Reward Type ${index + 1}`] =
          '% discount on any items from a category';
        itemCategoryRewardPayload = reward.reward_items.reduce(
          (itemCategoryRewardPayload, item, index) => {
            itemCategoryRewardPayload[`Reward Item Category ${index + 1}`] =
              item.category_name;
            return itemCategoryRewardPayload;
          },
          {}
        );
      }
      rewardPayload[`Discount % ${index + 1} Value`] = `${reward.discount} %`;
    }
    rewardPayload[`Redeem Point ${index + 1}`] = reward.redeem_point;
    return rewardPayload;
  }, {});

  return {
    'Program Type': programType,
    'Transaction Value': transactionValue,
    'Transaction Point Amount': transactionPointAmount,
    'New Member Point Amount': newMemberPointAmount,
    ...itemProgramPayload,
    ...rewardPayload,
    ...itemRewardPayload,
    ...itemCategoryRewardPayload,
    'Send validation code': data.is_sent_validation_code,
  };
}

//* ***************  MANAGE EXISTING LOYALTY *************************

export function showManageLoyalty() {
  pushClevertapEvent('Loyalty Manage');
}

export function editProgramStart() {
  pushClevertapEvent('Loyalty Edit Start');
}

export function resetProgramStart() {
  pushClevertapEvent('Loyalty Reset Start');
}

export function reactivateLoyalty(data) {
  pushClevertapEvent(
    'Loyalty Reactivate',
    loyaltyProgramInfoToClevertapInfo(data)
  );
}

export function deactivateLoyalty(data) {
  pushClevertapEvent(
    'Loyalty Deactivate',
    loyaltyProgramInfoToClevertapInfo(data)
  );
}

export function resetLoyalty(data) {
  pushClevertapEvent(
    'Loyalty Reset Completed',
    loyaltyProgramInfoToClevertapInfo(data)
  );
}

export function editLoyalty(data) {
  pushClevertapEvent(
    'Loyalty Edit Completed',
    loyaltyProgramInfoToClevertapInfo(data)
  );
}

export function knowledgeCenterLinkClick() {
  pushClevertapEvent('Loyalty Knowledge Center');
}

export function loyaltyBlogLinkClick() {
  pushClevertapEvent('Loyalty Blog');
}
